import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminLinkTimeseriesQuery.ts
var r = (r, i, a) => t({
	queryKey: e.linkTimeseries(r, i, a),
	queryFn: () => n.linkTimeseries(r, i, a),
	enabled: !!r && !!i
});
//#endregion
export { r as useAdminLinkTimeseriesQuery };
